import { Component, Input, OnInit, ViewChild } from "@angular/core";
import { MatPaginator } from "@angular/material/paginator";
import * as moment from "moment";
import { EventService } from "src/app/services/event.service";
import {
  DutDetailsData,
  EpackPdfReportComponent,
  Page1TableData,
  Page2TableData,
  SummaryData,
} from "../epack-pdf-report/epack-pdf-report.component";
import { MatTableDataSource } from "@angular/material/table";
import { DataService } from "src/app/services/data.service";
import Swal from "sweetalert2";
import { MatDialog } from "@angular/material/dialog";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
import { Router } from "@angular/router";
import { EpackEolDialogComponent } from "../epack-dialouge/epack-dialouge.component";

interface FileData {
  user: string;
  metaData: MetaData;
}

interface MetaData {
  test_date: string;
  timestamp: number;
  battery_unique_key: number;
  bms_id: number;
  fileUrl: string;
  fileName: string;
}

interface EpackEolDataWithTestRig {
  test_rig_number: string;
  test_id: string;
  pack_id: string;
  test_stage: number;
  test_status: string;
  user_id: string;
  fileData: FileData;
  bms_id: string;
  created_at: string;
  updated_at: string;
  test_end_time: string;
  final_eol_result: string;
}

interface EpackEolTableData {
  "S.No": number;
  "Test Status": string;
  "Rig No"?: string;
  "Test ID": string;
  "Start Date": string;
  "End Date"?: string;
  "Battery ID": string | number;
  "BMS ID": string | number;
  fileName: string;
  "Test Stage"?: string;
  final_eol_result?: string;
}

@Component({
  selector: "app-picolo-epack-dashboard-table",
  templateUrl: "./picolo-epack-dashboard-table.component.html",
  styleUrls: ["./picolo-epack-dashboard-table.component.css"],
})
export class PicoloEpackDashboardTableComponent implements OnInit {
  constructor(
    private eventService: EventService,
    private dataService: DataService,
    private dialog: MatDialog,
    private sanitizer: DomSanitizer,
    private router: Router,
  ) {}

  @Input() packId: string;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(EpackPdfReportComponent)
  picoloEpackPdfReportComponent: EpackPdfReportComponent;
  @ViewChild(EpackPdfReportComponent)
  epackPdfReportComponent: EpackPdfReportComponent;

  picoloEpackEolTableData: MatTableDataSource<EpackEolTableData> =
    new MatTableDataSource<EpackEolTableData>([]);
  tableIcons: {
    pt: string;
    ft: string;
    csv: string;
  } = {
    pt: "assets/img/epack-dashboard/PT.png",
    ft: "assets/img/epack-dashboard/FT.png",
    csv: "assets/img/epack-dashboard/CSV.png",
  };

  PicoloEpackEolTableHeaders: string[] = [
    "S.No",
    "Test ID",
    "Rig No",
    "Battery ID",
    "Test Stage",
    "Test Status",
    "Start Date",
    "End Date",
    "Analytics",
    "Download",
  ];

  ngOnInit(): void {
    this.getEpackEolDataByTestRig();
  }

  getEpackEolDataByTestRig() {
    this.eventService
      .getPicoloEpackEolDataByTestRig()
      .subscribe(
        (res: { success: boolean; data: EpackEolDataWithTestRig[] }) => {
          if (res.success) {
            this.setTableData(res.data);
          }
        },
      );
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.picoloEpackEolTableData.filter = filterValue.trim().toLowerCase();

    if (this.picoloEpackEolTableData.paginator) {
      this.picoloEpackEolTableData.paginator.firstPage();
    }
  }
  downloadPreTestPdfReport(testId: string) {
    this.dataService
      .getpreTestPdfPresignedUrl(testId)
      .subscribe((res: { success: boolean; data: string; message: string }) => {
        if (res.success) {
          if (res.data) {
            // opens direct download link
            window.location.href = res.data;
          } else {
            Swal.fire({
              icon: "error",
              title: "Error",
              text: res.message ?? "",
            });
          }
        } else {
          Swal.fire({
            icon: "error",
            title: "Error",
            text: res.message ?? "",
          });
        }
      });
  }

  downloadEpackPdfReport(testId: string, testDate: string) {
    this.eventService.getPicoloMetaDataByTestId({ testId: testId }).subscribe(
      (res: {
        success: boolean;
        data: {
          [key: string]: string;
        };
        summaryData: {
          [key: string]: string;
        };
        rig_id: string;
      }) => {
        if (res.success) {
          const {
            comp_bootloader,
            comp_application_fw,
            comp_application_hw,
            summary_pretests,
            summary_calibration,
            summary_discharge,
            summary_charge,
            summary_oem,
            final_eol_result,
          } = res.summaryData;
          const {
            // DUT Data
            bms_id,
            battery_id,
            product_id,
            variant_id,
            bms_hw_version,
            ratedCapacity: rated_capacity,
            ipqc_final_result,
            // Page 1 PDF data
            battery_weight,
            pdrop,
            discharge_precharge_ratio,
            Discharge_Path_Inactive,
            Discharge_Contactor_Health,
            charge_precharge_ratio,
            ChargePathInactive,
            Charge_Contactor_Health,
            discharge_negative_body,
            charge_negative_body,
            discharge_positive_body,
            V_ID_3,
            V_ID_2,
            V_ID_4,

            // result data for page 1
            weight_status,
            cp_pressure_drop_status,
            dischrg_prechrg_result,
            dischrg_path_health_result,
            chrg_prechrge_result,
            chrg_path_health_result,
            ir_discharge_neg_status,
            ir_charge_neg_status,
            ir_charge_pos_status,
            pre_sensor_gain_readback_analytics,
            offset_readback_analytics,
            post_sensor_analytics,
            NA = "N/A",
            voltage_imbalance_analytics,
            dischrg_delta_ah_analytics,
            ncpd_analytics,
            chrg_volt_imblnc_2min_crnt_analytics,
            chrg_volt_imblnc_analytics,
            chrg_max_temp_imblnc_analytics,
            chrg_ah_bms_analytics,
            chrg_ah_ivt_analytics,
            chrg_ah_delta_bms_ivt_analytics,
            ncpc_analytics,
            thremistor_hlth_chck_analytics,
            max_cell_temp_analytics,
            chrg_precool_time_analytics,
            chrg_delta_temp_imblnc_analytics,
            bootloader_version_analytics,
            firmware_version_analytics,
            soc_declaration_analytics,
            charge_cycle_count_analytics,
            bms_crnt_idle_crnt_chk_analytics,
            offset_adc_slow_chrg_analytics,
            can_health_result,

            // Page 2 PDF data
            V_ID_7,
            V_ID_6,
            V_ID_9,
            V_ID_8,
            V_ID_10,
            V_ID_11,
            V_ID_19,
            V_ID_28,
            V_ID_17,
            V_ID_26,
            V_ID_32,
            V_ID_31,
            V_ID_33,
            V_ID_34,
            V_ID_35,
            V_ID_27,
            V_ID_21,
            V_ID_20,
            V_ID_22_1,
            V_ID_23_1,
            V_ID_25,
            V_ID_30,
            V_ID_15,
            V_ID_18,
            V_ID_40,
            V_ID_41,
            V_ID_42,
            V_ID_43,
            V_ID_44,
            V_ID_45,
            user_soc_strg_readinss,
            chrg_cycl_count_slow_chrg,
            bms_crnt_idle_crnt_chk,
            offset_adc_slow_chrg,
            TBD,
            bms_fw_homo_minor_firmware,
            bms_fw_homo_major_firmware,
            max_charge_contactor_temp_analytics,
            max_shunt_temp_chrg_analytics,
            max_shunt_temp_dischrg_analytics,
            max_dischrg_contactor_analytics,
            pack_resistance_analytics,
            charge_time_analytics,
          } = res.data;

          // !TODO: hardcoded for Picolo until product variant configuration is added
          let ratedCapacity = "PL1";

          const app_homologation_analytics = `${
            bms_fw_homo_minor_firmware?.trim() ?? "--"
          }${bms_fw_homo_major_firmware?.trim() ?? "--"}`;
          const app_homologation_result =
            app_homologation_analytics === "11" ? "Pass" : "Fail";

          if (rated_capacity) {
            const data: any = rated_capacity;
            ratedCapacity = `${data?.value} ${data.unit}`;
          }

          let dutIndividualData: DutDetailsData = {
            "Test ID": {
              dataValue: testId,
            },
            "Test Date": { dataValue: testDate },
            "Battery Unique ID": {
              dataValue: battery_id,
            },
            "BMS Unique ID": {
              dataValue: bms_id,
            },
            "Hardware Version": {
              dataValue: bms_hw_version,
            },
            "Variant (assigned during EOL)": {
              dataValue: variant_id,
            },
            Product: {
              dataValue: product_id,
            },
            "Test Rig": {
              dataValue: res.rig_id ?? "---",
            },
            "Nominal voltage": {
              dataValue: "51.25 V",
            },
            "Rated capacity": {
              dataValue: ratedCapacity,
            },
          };

          let page1TableData: Page1TableData = {
            Pretests: [
              // {
              //   test: "Sticker / Engraving present",
              //   analytics: "Present",
              //   unit: "N/A",
              //   result: "PASS",
              // },
              {
                test: "Weight",
                result: weight_status,
                unit: "KG",
                analytics: battery_weight,
              },
              {
                test: "Cold Plate static pressure drop",
                result: cp_pressure_drop_status,
                unit: "bar",
                analytics: pdrop,
              },
              {
                test: "Discharge Pre-charge",
                result: dischrg_prechrg_result,
                unit: "Ratio",
                analytics: discharge_precharge_ratio,
              },
              {
                test: "Discharge Path Inactive",
                result: chrg_path_health_result,
                unit: "V",
                analytics: Discharge_Path_Inactive,
              },
              {
                test: "Discharge Contactor Health",
                result: dischrg_path_health_result,
                unit: "V",
                analytics: Discharge_Contactor_Health,
              },
              {
                test: "Charge Pre-charge",
                result: chrg_prechrge_result,
                unit: NA,
                analytics: charge_precharge_ratio,
              },
              {
                test: "Charge Path Inactive",
                result: dischrg_path_health_result,
                unit: "V",
                analytics: ChargePathInactive,
              },
              {
                test: "Charge Contactor Health",
                result: chrg_path_health_result,
                unit: "V",
                analytics: Charge_Contactor_Health,
              },
              {
                test: "Insulation Resistance - Discharge -Ve to Body",
                result: ir_discharge_neg_status,
                unit: "MOhms",
                analytics: discharge_negative_body,
              },
              {
                test: "Insulation Resistance - Charge -Ve to Body",
                result: ir_charge_neg_status,
                unit: "MOhms",
                analytics: charge_negative_body,
              },
              {
                test: "Insulation Resistance - Charge +Ve to Body",
                result: ir_charge_pos_status,
                unit: "MOhms",
                analytics: discharge_positive_body,
              },
              {
                test: "CAN Health Result",
                result: can_health_result,
                unit: NA,
                analytics: "----",
              },
            ],
            Calibration: [
              {
                test: "Gain",
                result: pre_sensor_gain_readback_analytics,
                unit: "Gain Factor",
                analytics: V_ID_3,
              },
              {
                test: "Offset",
                result: offset_readback_analytics,
                unit: "ADC",
                analytics: V_ID_2,
              },
              {
                test: "Error Post Calibration",
                result: post_sensor_analytics,
                unit: "A",
                analytics: V_ID_4,
              },
            ],
            Discharge: [
              {
                test: "Temperature imbalance at end of discharge cycle",
                result: NA,
                unit: "°C",
                analytics: V_ID_7,
              },
              {
                test: "Voltage imbalance 5 mins after end of discharge cycle",
                result: voltage_imbalance_analytics,
                unit: "mv",
                analytics: V_ID_6,
              },
              {
                test: "Discharge Ah- BMS",
                result: NA,
                unit: "Ah",
                analytics: V_ID_9,
              },
              {
                test: "Discharge Ah- IVT",
                result: NA,
                unit: "Ah",
                analytics: V_ID_8,
              },
              {
                test: "Discharge Ah- Delta",
                result: dischrg_delta_ah_analytics,
                unit: "Ah",
                analytics: V_ID_10,
              },
              {
                test: "Max Discharge Contactor Temperature during Discharge",
                result: max_dischrg_contactor_analytics,
                unit: "°C",
                analytics: V_ID_43,
              },
              {
                test: "Max Shunt Temperature during Discharge",
                result: max_shunt_temp_dischrg_analytics,
                unit: "°C",
                analytics: V_ID_44,
              },
              {
                test: "Non Cell - Discharge Path Resistance",
                result: ncpd_analytics,
                unit: "mOhms",
                analytics: V_ID_11,
              },
            ],
          };

          let page2TableData: Page2TableData = {
            Charge: [
              {
                test: "Voltage Imbalance 2 Min after current passing",
                result: chrg_volt_imblnc_2min_crnt_analytics,
                unit: "mv",
                analytics: V_ID_19,
              },
              {
                test: "Voltage Imbalance end of Charge Cycle",
                result: chrg_volt_imblnc_analytics,
                unit: "mv",
                analytics: V_ID_28,
              },
              {
                test: "Temperature imbalance at Start of Charge",
                result: NA,
                unit: "°C",
                analytics: V_ID_17,
              },
              {
                test: "Maximum Temp. Imbalance during Charge",
                result: chrg_max_temp_imblnc_analytics,
                unit: "°C",
                analytics: V_ID_26,
              },
              {
                test: "Charge Ah- BMS",
                result: chrg_ah_bms_analytics,
                unit: "Ah",
                analytics: V_ID_32,
              },
              {
                test: "Charge Ah- IVT",
                result: chrg_ah_ivt_analytics,
                unit: "Ah",
                analytics: V_ID_31,
              },
              {
                test: "Charge Ah- Delta",
                result: chrg_ah_delta_bms_ivt_analytics,
                unit: "Ah",
                analytics: V_ID_33,
              },
              {
                test: "Non Cell - Charge Path Resistance",
                result: ncpc_analytics,
                unit: "mOhms",
                analytics: V_ID_34,
              },
              {
                test: "Thermistor Health",
                result: thremistor_hlth_chck_analytics,
                unit: "Flag",
                analytics: V_ID_35,
              },
              {
                test: "Pack Resistance during Charge",
                result: pack_resistance_analytics,
                unit: "mOhms",
                analytics: V_ID_40,
              },
              {
                test: "Max Charge Contactor Temperature during Charge",
                result: max_charge_contactor_temp_analytics,
                unit: "°C",
                analytics: V_ID_41,
              },
              {
                test: "Max Shunt Temperature during Charge",
                result: max_shunt_temp_chrg_analytics,
                unit: "°C",
                analytics: V_ID_42,
              },
              {
                test: "Average Inlet Fluid Temperature during Precool",
                result: NA,
                unit: "°C",
                analytics: V_ID_45,
              },
              {
                test: "Max Cell Temperature",
                result: max_cell_temp_analytics,
                unit: "°C",
                analytics: V_ID_27,
              },
              {
                test: "Average Flow rate",
                result: NA,
                unit: "LPM",
                analytics: V_ID_21,
              },
              {
                test: "Pressure drop at start of charge",
                result: NA,
                unit: "bar",
                analytics: V_ID_20,
              },
              {
                test: "Average Inlet Fluid Temperature during Charge",
                result: NA,
                unit: "°C",
                analytics: V_ID_22_1,
              },
              {
                test: "Average Outlet Fluid Temperature during Charge",
                result: NA,
                unit: "°C",
                analytics: V_ID_23_1,
              },
              {
                test: "Charge Fluid Temperature Rise",
                result: NA,
                unit: "°C",
                analytics: V_ID_25,
              },
              {
                test: "Charge Time",
                result: charge_time_analytics,
                unit: "Seconds",
                analytics: V_ID_30,
              },
              {
                test: "Pre Cool Time",
                result: chrg_precool_time_analytics,
                unit: "Seconds",
                analytics: V_ID_15,
              },
              {
                test: "Pre Cool Temp. Imbalance",
                result: chrg_delta_temp_imblnc_analytics,
                unit: "°C",
                analytics: V_ID_18,
              },
            ],
            "OEM Storage": [
              {
                test: "Bootloader - Firmware Version (veh_bl_heartbeat)",
                result: bootloader_version_analytics,
                unit: "Version",
                analytics: comp_bootloader,
              },
              {
                test: "Application FW - Firmware Version (bms_fw_version)",
                result: firmware_version_analytics,
                unit: "Version",
                analytics: comp_application_fw,
              },
              {
                test: "Application HW - Firmware Version (bms_oem_hw_pack_version)",
                result: firmware_version_analytics,
                unit: "Version",
                analytics: comp_application_hw,
              },
              {
                test: "Application Homologation - Firmware Version",
                result: app_homologation_result,
                unit: "Version",
                analytics: app_homologation_analytics,
              },
              {
                test: "SOC Declaration",
                result: soc_declaration_analytics,
                unit: "% SoC",
                analytics: user_soc_strg_readinss,
              },
              {
                test: "Charge cycle count",
                result: charge_cycle_count_analytics,
                unit: "Cycle Count",
                analytics: chrg_cycl_count_slow_chrg,
              },
              {
                test: "Idle current check",
                result: bms_crnt_idle_crnt_chk_analytics,
                unit: "A",
                analytics: bms_crnt_idle_crnt_chk,
              },
              {
                test: "Offset ADC post EOL",
                result: offset_adc_slow_chrg_analytics,
                unit: "ADC",
                analytics: offset_adc_slow_chrg,
              },
            ],
            "IP67 Test": [
              {
                test: "Battery Pack Leak Test",
                result: "---",
                unit: "Pa",
                analytics: TBD,
              },
              {
                test: "Vent Leak Test",
                result: "---",
                unit: "Pa",
                analytics: TBD,
              },
            ],
          };

          const isPassingTest =
            final_eol_result?.trim().toLowerCase() === "pass" &&
            ipqc_final_result?.trim().toLowerCase() === "pass";

          let summaryData: SummaryData = {
            "EOL + BMS IPQC Result": {
              dataValue: isPassingTest ? "Pass" : "Fail",
            },
            "EOL Result": { dataValue: final_eol_result },
            "BMS IPQC Result": { dataValue: ipqc_final_result ?? "---" },
            Pretests: { dataValue: summary_pretests },
            Calibration: { dataValue: summary_calibration },
            Discharge: { dataValue: summary_discharge },
            Charge: { dataValue: summary_charge },
            "OEM Storage": { dataValue: summary_oem },
          };

          // if DUT data doesn't exist then set it to "----"
          Object.entries(dutIndividualData).forEach(([key, value]) => {
            dutIndividualData[key] = value?.dataValue ?? "----";
          });

          // if table data doesn't exist then set it to "----"
          Object.entries(page1TableData).forEach(([groupKey, Group]) => {
            Object.entries(Group).forEach(([key, value]) => {
              const val: any = value;
              page1TableData[groupKey][key].analytics =
                val?.analytics ?? "----";
              page1TableData[groupKey][key].result = val?.result ?? "----";
            });
          }); // if table data doesn't exist then set it to "----"

          Object.entries(page2TableData).forEach(([groupKey, Group]) => {
            Object.entries(Group).forEach(([key, value]) => {
              const val: any = value;
              page2TableData[groupKey][key].analytics =
                val?.analytics ?? "----";
              page2TableData[groupKey][key].result = val?.result ?? "----";
            });
          });

          // console.group("DUT Details");
          // console.log(dutIndividualData);
          // console.groupEnd();

          // console.group("Summary Data");
          // console.log(summaryData);
          // console.groupEnd();

          // console.group("Page 1 Table Data");
          // console.log(page1TableData);
          // console.groupEnd();

          // console.group("Page 2 Table Data");
          // console.log(page2TableData);
          // console.groupEnd();

          this.epackPdfReportComponent.downloadReport({
            dutDetailsData: dutIndividualData,
            summaryData: summaryData,
            page1TableData: page1TableData,
            page2TableData: page2TableData,
            battery_type: "piccolo",
          });
        }
      },
    );
  }

  downloadEpackEolFile(fileName: string, testId: string) {
    this.dataService.downloadExponentEpackEOLFile(fileName, testId).subscribe(
      (res: any) => {
        if (res.status) {
          if (!res.result) {
            Swal.fire({
              icon: "error",
              title: "Error",
              text: "No file found for selected test",
            });
          } else {
            window.location.href = res.result;
          }
        }
      },
      (err) => {
        console.log("ERR: ", err);
      },
    );
  }

  async openDialog(
    testId: string,
    testDate: string,
    packId: string,
    bmsId: string,
    rigNum: string,
  ) {
    const testMetaData = await this.getGroupedMetaDataByTestid(testId);

    let ratedCapacity = "---";

    if (testMetaData?.dialougeData?.ratedCapacity) {
      const data: any = testMetaData?.dialougeData?.ratedCapacity;
      ratedCapacity = `${data.value} ${data.unit}`;
    }

    const headerData = {
      "Test ID": testId,
      "Test Date": testDate,
      "Battery Unique ID": packId,
      "BMS Unique ID": bmsId,
      "Hardware Version": testMetaData?.dialougeData?.hardware_version ?? "---",
      "Variant (assigned during EOL)":
        testMetaData?.dialougeData?.variant ?? "---",
      Product: testMetaData?.dialougeData?.product ?? "---",
      "Test Rig": rigNum,
      "Nominal voltage": "51.25 V",
      "Rated capacity": ratedCapacity,
    };

    const data = {
      headerData,
      content: this.generateGroupedMetaDataDialogData(testMetaData.data),
    };

    this.dialog.open(EpackEolDialogComponent, {
      height: "95%",
      width: "90%",
      maxWidth: "1250px",
      autoFocus: true,
      data,
    });
  }

  renderRawDataGraph(testId: string, testDate: string) {
    if (!this.validateTestCompletion(testId)) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "No test data available. Test must be completed to view raw data",
      });
      return;
    }

    // set data to local storage
    const payload = { testId, testDate };
    localStorage.setItem("epackRawDataInfo", JSON.stringify(payload));
    this.router.navigate(["eol/raw-data"]);
  }

  renderAnalyticsGrpah(testId: string, testDate: string) {
    if (!this.validateTestCompletion(testId)) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "No test data available. Test must be completed to view analytics",
      });
      return;
    }

    const splitedDate = testDate.split("-");

    const year = splitedDate[2];
    const month = splitedDate[1];
    const date = splitedDate[0];
    const fullDate = new Date(`${year}-${month}-${date}`);

    localStorage.setItem(
      "analyticsRawDataInfo",
      JSON.stringify({
        testId,
        year,
        month,
        date,
        fullDate,
      }),
    );

    this.router.navigate(["eol/graph"]);
  }

  setTableData(data: EpackEolDataWithTestRig[]) {
    const resData: EpackEolTableData[] = data.map((data, index) => {
      const {
        bms_id,
        final_eol_result,
        fileData,
        pack_id,
        test_id,
        test_rig_number,
        test_stage,
        test_status,
        user_id,
        created_at: test_date,
        test_end_time: end_date,
      } = data;

      const start_date_string = moment.utc(test_date).format("DD-MM-YYYY");
      const end_date_string = end_date
        ? moment.utc(end_date).format("DD-MM-YYYY")
        : "N/A";

      const fileExists = fileData?.metaData?.fileName ? true : false;
      return {
        "Battery ID": pack_id,
        "BMS ID": bms_id,
        "Start Date": start_date_string,
        "End Date": end_date_string,
        "Test ID": test_id,
        "S.No": index + 1,
        fileName: fileData?.metaData?.fileName,
        "Test Stage": fileExists ? "EOL Test Completed" : test_status,
        "Test Status": final_eol_result ?? "In Progress",
        "Rig No": test_rig_number,
      };
    });

    if (this.packId) {
      this.picoloEpackEolTableData = new MatTableDataSource<EpackEolTableData>(
        resData
          .filter((_) => _["Battery ID"] === this.packId)
          .map((_, i) => ({ ..._, "S.No": i + 1 })),
      );
    } else {
      this.picoloEpackEolTableData = new MatTableDataSource<EpackEolTableData>(
        resData,
      );
    }

    this.picoloEpackEolTableData.paginator = this.paginator;
  }

  generateGroupedMetaDataDialogData(dataByMajorGroup: {
    [index: string]: string | number | null;
  }): SafeHtml {
    const majorGroups = Object.keys(dataByMajorGroup).filter(
      (group) => group !== "NA",
    );

    const mainDataContainer = document.createElement("section");
    mainDataContainer.id = "metaDataContainer";
    mainDataContainer.style.textAlign = "center";

    majorGroups.forEach((majorGroup) => {
      // creating major container
      const majorGroupContainer = document.createElement("section");
      majorGroupContainer.classList.add("majorGroupContianer");
      majorGroupContainer.style.backgroundColor = "#E4E2E2";
      majorGroupContainer.style.border = "1px solid #A3A3A3";
      majorGroupContainer.style.marginTop = "1.5rem";
      majorGroupContainer.style.paddingBottom = "1rem";

      const majorGroupHeader = document.createElement("h2");
      majorGroupHeader.classList.add("majorGroupHeader");
      majorGroupHeader.style.backgroundColor = "#BEBEBE";
      majorGroupHeader.style.padding = "0.5rem";
      majorGroupHeader.style.marginBottom = "1rem";
      majorGroupHeader.style.fontSize = "1.2rem";
      majorGroupHeader.style.margin = "0";

      majorGroupHeader.innerText = majorGroup;

      majorGroupContainer.appendChild(majorGroupHeader);

      // creating minor container
      const minorGroups = Object.keys(dataByMajorGroup[majorGroup]);
      minorGroups.forEach((minorGroup, index) => {
        const minorGroupContainer = document.createElement("section");
        minorGroupContainer.classList.add("minorSectionContainer");
        minorGroupContainer.style.backgroundColor = "#f1f1f1";
        minorGroupContainer.style.border = "1px solid #A3A3A3";
        minorGroupContainer.style.margin = "auto 0.3rem";
        minorGroupContainer.style.marginTop = "1.5rem";
        minorGroupContainer.style.boxShadow =
          "rgba(0, 0, 0, 0.35) 0px 5px 15px;";

        if (index === 0) {
          minorGroupContainer.style.marginTop = "0.5rem";
        }

        const minorGroupHeader = document.createElement("h2");
        minorGroupHeader.classList.add("minorGroupHeader");
        minorGroupHeader.style.backgroundColor = "#CFCFCF";
        minorGroupHeader.style.padding = "0.2rem";
        minorGroupHeader.style.fontSize = "1rem";
        minorGroupHeader.innerText = minorGroup;
        minorGroupHeader.style.margin = "0";
        minorGroupHeader.style.borderBottom = "1px solid #b5b5b5";
        minorGroupContainer.appendChild(minorGroupHeader);

        const metaDataContainer = document.createElement("section");
        // metadataContainer.classList.add("metaDataContainer");
        metaDataContainer.style.display = "grid";
        metaDataContainer.style.gridTemplateColumns = "repeat(4, 1fr)";
        metaDataContainer.style.gap = "0.5rem";
        metaDataContainer.style.padding = "0.6rem";

        const metaData = dataByMajorGroup[majorGroup][minorGroup];

        if (metaData.length > 0) {
          metaData.forEach((currentMetaData) => {
            const metaDataCard = document.createElement("div");
            const metaDataTitle = document.createElement("h4");
            const metaDataValue = document.createElement("p");

            metaDataTitle.innerText = Object.keys(currentMetaData)[0];
            metaDataValue.innerText = String(Object.values(currentMetaData)[0]);

            metaDataCard.style.display = "flex";
            metaDataCard.style.flexDirection = "column";
            metaDataCard.style.alignItems = "center";
            metaDataCard.style.justifyContent = "space-between";
            metaDataCard.style.border = "1.2px solid #A3A3A390";
            metaDataCard.style.backgroundColor = "#c7c7c7";
            metaDataCard.style.boxShadow = "rgba(0, 0, 0, 0.04) 0px 3px 5px;";

            metaDataTitle.style.padding = "0.5rem";
            metaDataTitle.style.margin = "0";

            metaDataValue.style.padding = "0.5rem";
            metaDataValue.style.margin = "0";
            metaDataValue.style.width = "100%";
            metaDataValue.style.backgroundColor = "#f1f1f1";
            metaDataValue.style.fontWeight = "500";

            if (
              String(Object.values(currentMetaData)[0])
                ?.trim()
                .toLowerCase() === "fail"
            ) {
              metaDataCard.style.border = "1.2px solid #B90000";
              metaDataCard.style.backgroundColor = "#ff2f3640";
              metaDataTitle.style.color = "#B90000";
              metaDataValue.style.color = "#B90000";
            }

            metaDataCard.appendChild(metaDataTitle);
            metaDataCard.appendChild(metaDataValue);
            metaDataContainer.appendChild(metaDataCard);
          });

          minorGroupContainer.appendChild(metaDataContainer);
        } else {
          const noDataContainer = document.createElement("p");
          noDataContainer.style.padding = "0.5rem";
          noDataContainer.style.margin = "0";
          noDataContainer.innerText = "No Data Found";
          noDataContainer.classList.add("noDataContainer");
          minorGroupContainer.appendChild(noDataContainer);
        }

        majorGroupContainer.appendChild(minorGroupContainer);
      });

      mainDataContainer.appendChild(majorGroupContainer);
    });

    const content = document.createElement("div");
    content.appendChild(mainDataContainer);

    return this.sanitizer.bypassSecurityTrustHtml(content.innerHTML);
  }

  getGroupedMetaDataByTestid(testId: string): Promise<{
    data: {
      [key: string]: string | number | null;
    };
    dialougeData: { [key: string]: string | number | null };
  }> {
    return new Promise((resolve) => {
      this.eventService.getPicoloGroupedMetaDataByTestid(testId).subscribe(
        (res: {
          success: boolean;
          message: string;
          dialougeData: { [key: string]: string | number | null };
          data: { [key: string]: string | number | null };
        }) => {
          if (res.success) {
            resolve({
              dialougeData: res.dialougeData,
              data: res.data,
            });
          } else {
            Swal.fire({
              icon: "error",
              text: res.message,
            });
          }
        },
        (err) => {
          console.log(err.message);
        },
      );
    });
  }

  validateTestCompletion(testId: string): boolean {
    const testData = this.picoloEpackEolTableData.data.find(
      (_) => _["Test ID"] === testId,
    );

    if (!testData) {
      return false;
    }

    const testStatus = testData["Test Status"].trim().toLowerCase();
    const isTestCompleted = testStatus === "pass" || testStatus === "fail";
    return isTestCompleted;
  }
}
